export default "/images/info.svg?ebce7ea8bd8d54bb08dc80b9cf745982";